"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.withQueryParam = withQueryParam;
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
/**
 * Append a param and paramValue to the query of a given url or path. This method
 * does not check if the param already exists on the provided url
 * @param {string} stringUrlOrPath
 * @param {*} param
 * @param {*} paramValue
 * @returns {string} new string with param appended
 */
function withQueryParam() {
  let stringUrlOrPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let param = arguments.length > 1 ? arguments[1] : undefined;
  let paramValue = arguments.length > 2 ? arguments[2] : undefined;
  // don't append undefined values
  if (typeof paramValue === 'undefined') {
    return stringUrlOrPath;
  }
  const prefix = (0, _indexOf.default)(stringUrlOrPath).call(stringUrlOrPath, '?') > -1 ? '&' : '?';
  return `${stringUrlOrPath}${prefix}${param}=${encodeURIComponent(paramValue)}`;
}